export const generateLocalizedPath = (path: string, locale: string): string => {
  if (!path.startsWith('/')) {
    return path;
  }

  if (locale === 'en') {
    return path;
  }

  return `/${locale}${path}`;
};
